import Flashv2 from '@shared/services/flashv2.js';

let setupFlashMessageEvents = function($rootScope, $state, Flash) {
  $rootScope.$on('$stateChangeStart', function(e, toState, toParams, fromState, fromParams) {
    Flashv2.clear();
  });

  $rootScope.$on('$stateChangeSuccess', function(e, toState, toParams, fromState, fromParams) {
    Flashv2.showQueuedMessages();
  });
};

export default setupFlashMessageEvents;
